import EventSelect from "./events-select";
import EventRadioSelect from "./events-radio-select";


const EventFormItems = {
    Select: EventSelect,
    RadioSelect: EventRadioSelect,
};

export default EventFormItems;